var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "btn app-generic-toggle text-nowrap",
      class: [_vm.containerClass, _vm.buttonClass, _vm.sizeClass],
      attrs: { disabled: _vm.readOnly, title: _vm.toolTip },
      on: { click: _vm.toggle },
    },
    [
      _c("span", { staticClass: "fa", class: [_vm.iconClass] }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.label,
              expression: "label",
            },
          ],
        },
        [_vm._v(_vm._s(_vm.label))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }